import { type ReactNode, useCallback } from 'react';

import ModuleImpressionEvent, {
  type ModuleDisplayType
} from '~/events/ModuleImpressionEvent';
import useImpression from '~/hooks/useImpression';
import useRootData from '~/hooks/useRootData';
import useUser from '~/hooks/useUser';

type Props = {
  children: ReactNode;
  columnCount?: number;
  displayType?: ModuleDisplayType;
  itemCount?: number;
  modulePosition?: number;
  moduleType: string;
};

export default function ModuleImpression({
  children,
  columnCount,
  displayType,
  itemCount,
  modulePosition,
  moduleType
}: Props) {
  const { isBot } = useRootData();
  const { guestId } = useUser();

  const track = useCallback(() => {
    new ModuleImpressionEvent({
      columnCount,
      displayType,
      guestId,
      isBot,
      itemCount,
      modulePosition,
      moduleType
    }).track();
  }, [
    columnCount,
    displayType,
    guestId,
    isBot,
    itemCount,
    modulePosition,
    moduleType
  ]);

  const impressionRef = useImpression<HTMLDivElement>(track, {
    enabled: !isBot
  });

  return <div ref={impressionRef}>{children}</div>;
}
